import { useState } from 'react';

import { useOnScroll } from '../../../../hooks/UseOnScroll';

const useSavedSearchButton = () => {
  const [displaySaveSearch, setDisplaySaveSearch] = useState(true);

  useOnScroll({
    onScrollDown: () => setDisplaySaveSearch(false),
    onScrollUp: () => setDisplaySaveSearch(true),
  });

  return {
    displaySaveSearch,
  };
};

export { useSavedSearchButton };
